import type { FC } from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import { useQueryPopupOpen } from '@mwl/core-lib';
import type { ButtonAsLink } from '@/components/Button/Button';
import { Button } from '@/components/Button/Button';
import styles from './SignUpButton.module.scss';
const SignUpButton: FC = () => {
  const {
    t
  } = useTranslation();
  const {
    createLinkProps
  } = useQueryPopupOpen();
  const registerProps = useMemo<Omit<ButtonAsLink, 'children' | 'as'>>(() => {
    return createLinkProps({
      queryName: 'register'
    });
  }, [createLinkProps]);
  return <Button variant="filled" {...registerProps} color="red" as="link" fontWeight="bold" rounded className={styles.signButton} data-sentry-element="Button" data-sentry-component="SignUpButton" data-sentry-source-file="SignUpButton.tsx">
      <div className={styles.text}>{t('button.signup', 'sign up')}</div>
    </Button>;
};
export { SignUpButton };